module.exports = __webpack_public_path__ + "static/media/mixerIcon.9fe38e1a.svg";